
export default {
  titleField: 'name',
  fields: [
    {
      name: 'type',
      label: "type",
      type: 'select',
      inList: true,
    },
    {
      name: 'name',
      label: "Nom",
      type: 'text',
      inList: true,
    },
    {
      name: 'internal_code',
      label: "Code interne",
      type: 'text',
      inList: true,
    },
    {
      name: 'equipment_group',
      label: "Famille",
      type: 'select',
      inList: true,
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'stock',
      label: "Stock",
      type: 'number',
      inList: true,
    },
    {
      name: 'rent_count',
      label: "En location",
      type: 'number',
      inList: true,
    },
    {
      name: 'maintenance_count',
      label: "En maintenance",
      type: 'number',
      inList: true,
    },
    {
      name: 'lost_count',
      label: "Perdu/Volés",
      type: 'number',
      inList: true,
    },
    {
      name: 'trash_count',
      label: "Au rebut",
      type: 'number',
      inList: true,
    },
    {
      name: 'group_slug',
      label: "Service",
      type: 'select',
      inList: true,
    },
    {
      name: 'status',
      label: "Statut",
      type: 'select',
      inList: true,
      formatter: (context, value) => value && value.name ? value.name : null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/RelatedProduct/config.js